import React, {useState} from 'react';
import {useHistory} from 'react-router-dom';
import InfoForm from './InfoForm';
import Navbar from '../Common/Navbar';
import Closing from '../Common/Closing';


const MyInformation = () => {
    const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')));
    const history = useHistory();
    const goToHomepage = () =>{
        history.push('/')
    }
    return (
        <div>
            <Navbar />
            {!user && goToHomepage()}
            <InfoForm user = {user} />
            <Closing />
        </div>
    )
}

export default MyInformation
